import styled from "styled-components";
import { TABLET_M_BP } from "@website-builder/utilities/constants/style-constants/screen-sizes.js";
import { getAnchorStyles } from "@website-builder/utilities/utils/DesignUtils.js";

export const AccordionContentWrapper = styled.div`
	display: flex;
	gap: 1rem;
	flex-direction: column;
	.accordion-content {
		display: flex;
		align-items: start;
		justify-content: space-between;
	}
	.footer-text {
		${(props) => (props.footerTextHasMargin ? "margin-top: 1rem;" : "")}
	}
	.rich-text-wrapper {
		${process.env.GATSBY_BUSINESS_VERTICAL === "b2u" && getAnchorStyles()}
	}
	.footer-cta {
		width: fit-content;
	}
	.accordion-content-text-heading {
		width: 45%;
	}
	.accordion-content-text-value {
		width: 35%;
	}
	@media only screen and (max-width: ${TABLET_M_BP}px) {
		.accordion-content-text-heading {
			width: 50%;
		}
		.accordion-content-text-value {
			width: 50%;
		}
	}
	.text-end {
		text-align: end;
	}
`;

export const AccordionHeadingWrapper = styled.div`
	width: 100%;
	display: flex;
	justify-content: space-between;
	gap: 1rem;
	.flex-gap_05 {
		display: flex;
		gap: 0.5rem;
	}

	.accordion-heading-line-through-price {
		text-decoration: line-through;
	}
	.accordion-heading-right-wrapper {
		max-width: 60%;
	}
	.accordion-heading-left-wrapper,
	.accordion-heading-right-wrapper {
		flex-direction: column;
	}
	.accordion-pricing-badge {
		height: 1.3rem;
	}
	.below-text {
		text-align: center;
	}
	@media only screen and (max-width: ${TABLET_M_BP}px) {
		gap: 0.5rem;
		.below-text {
			text-align: start;
		}
		.accordion-heading-right-wrapper {
			max-width: 100%;
		}
		flex-direction: column;
	}
`;
